import React, { useEffect, useState } from "react";
import axios from "axios";
import Style from "../Style/CourseMoreDiskView.module.scss";

const CourseMoreDiskView = () => {
  const [courseDetails, setCourseDetails] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({ description: "" });
  const baseURL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";

  useEffect(() => {
    const fetchCourseDetails = async () => {
      try {
        const response = await axios.get(`${baseURL}/api/course_detail`);
        setCourseDetails(response.data);
        setLoading(false);
      } catch (err) {
        console.error("Error fetching course details:", err);
        setError("Failed to load course details");
        setLoading(false);
      }
    };

    fetchCourseDetails();
  }, [baseURL]);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`${baseURL}/api/course_detail/${id}`);
      setCourseDetails(courseDetails.filter((item) => item.id !== id));
    } catch (err) {
      console.error("Error deleting course detail:", err);
    }
  };

  const handleEditClick = (course) => {
    setEditId(course.id);
    setFormData({ description: course.description });
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`${baseURL}/api/course_detail/${editId}`, formData);
      setCourseDetails(
        courseDetails.map((item) =>
          item.id === editId ? { ...item, ...formData } : item
        )
      );
      setEditId(null);
      setFormData({ description: "" });
    } catch (err) {
      console.error("Error updating course detail:", err);
    }
  };

  if (loading) return <p>Loading course details...</p>;
  if (error) return <p>{error}</p>;

  return (
    <div className={Style.courseDetailsContainer}>
      <h2 className={Style.heading}>Course Details</h2>
      {courseDetails.length === 0 ? (
        <p>No course details found.</p>
      ) : (
        <table className={Style.courseTable}>
          <thead>
            <tr>
              <th>ID</th>
              <th>Skill Detail ID</th>
              <th>Description</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {courseDetails.map((course) => (
              <tr key={course.id}>
                <td>{course.id}</td>
                <td>{course.skill_detail_id}</td>
                {editId === course.id ? (
                  <>
                    <td>
                      <textarea
                        className={Style.editTextarea}
                        value={formData.description}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            description: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className={Style.actionButtons}>
                      <button className={Style.saveBtn} onClick={handleUpdate}>
                        Save
                      </button>
                      <button
                        className={Style.cancelBtn}
                        onClick={() => setEditId(null)}
                      >
                        Cancel
                      </button>
                    </td>
                  </>
                ) : (
                  <>
                    <td className={Style.descriptionCell}>
                      <div
                        dangerouslySetInnerHTML={{ __html: course.description }}
                      />
                    </td>
                    <td className={Style.actionButtons}>
                      <button
                        className={Style.editBtn}
                        onClick={() => handleEditClick(course)}
                      >
                        Edit
                      </button>
                      <button
                        className={Style.deleteBtn}
                        onClick={() => handleDelete(course.id)}
                      >
                        Delete
                      </button>
                    </td>
                  </>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default CourseMoreDiskView;
